import { Link } from 'react-router-dom';
import { comics } from '@/mocks/data';

export default function LatestUpdates() {
  const latest = comics.slice(5, 9);

  return (
    <section className="bg-foreground-900 py-14 md:py-20">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="flex items-start gap-8 mb-10">
          <span className="whitespace-nowrap cursor-pointer border border-background-50/30 text-background-50 px-4 py-1.5 rounded-full text-xs font-medium">
            最新更新
          </span>
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-background-50 leading-tight">
            每日精选<br />新鲜上架
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group"
            >
              <div className="bg-background-100 rounded-lg overflow-hidden">
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 韩漫大全`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  />
                </div>
              </div>
              <div className="mt-3">
                <p className="text-sm font-medium text-background-50 group-hover:text-accent-400 transition-colors line-clamp-1">
                  {comic.title}
                </p>
                <p className="text-xs text-foreground-400 mt-0.5">{comic.latestChapter}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}